'use strict'

module.exports = collapse

/* collapse(' \t\nbar \nbaz\t'); // ' bar baz ' */
function collapse(value) {
  return String(value).replace(/\s+/g, ' ')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/collapse-white-space/index.js
// module id = ./node_modules/collapse-white-space/index.js
// module chunks = 0